/* eslint-disable id-blacklist */
export enum InputType {
  text = 'text',
  number = 'number',
  email = 'email',
  tel = 'tel',
  url = 'url',
  password = 'password',
  date = 'date',
  file = 'file',
}
